import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { expValEquals } from '@atlaskit/tmp-editor-statsig/exp-val-equals';
import { leafNodeReplacementCharacter, MAX_REGEX_MATCH, TEXT_INPUT_RULE_TRANSACTION_KEY, TYPEAHEAD_TRIGGERS } from './constants';
import { isGapCursorSelection } from './editor-common';
export var createInputEventHandler = function createInputEventHandler(_ref) {
  var rules = _ref.rules,
    pluginKey = _ref.pluginKey,
    allowInsertTextOnDocument = _ref.allowInsertTextOnDocument,
    onInputEvent = _ref.onInputEvent,
    onBeforeRegexMatch = _ref.onBeforeRegexMatch;
  return function (_ref2) {
    var view = _ref2.view,
      from = _ref2.from,
      to = _ref2.to,
      text = _ref2.text;
    if (view.composing) {
      return false;
    }
    var state = view.state;
    var $from = state.doc.resolve(from);
    if ($from.parent.type.spec.code) {
      return false;
    }
    if (onInputEvent && !onInputEvent({
      state: state,
      from: from,
      to: to
    })) {
      return false;
    }
    var textBefore = $from.parent.textBetween(Math.max(0, $from.parentOffset - MAX_REGEX_MATCH), $from.parentOffset, undefined, leafNodeReplacementCharacter) + text;
    var result = findMatchOnRules({
      rules: rules,
      textToMatch: textBefore,
      from: from,
      to: to,
      state: state
    });
    var isBackwardMatch;
    if (!result && expValEquals('platform_editor_lovability_inline_code', 'isEnabled', true)) {
      if (TYPEAHEAD_TRIGGERS.includes(text)) {
        return false;
      }
      var textAfter = text + $from.parent.textBetween($from.parentOffset, Math.min($from.parent.content.size, $from.parentOffset + MAX_REGEX_MATCH), undefined, leafNodeReplacementCharacter);
      isBackwardMatch = true;
      result = findMatchOnRules({
        rules: rules,
        textToMatch: textAfter,
        from: from,
        to: to,
        state: state,
        isBackwardMatch: isBackwardMatch
      });
      if (!result) {
        return false;
      }
    }
    if (!result) {
      return false;
    }
    var tr = allowInsertTextOnDocument ? state.tr.insertText(text, from, to) : state.tr;
    tr.setMeta(TEXT_INPUT_RULE_TRANSACTION_KEY, true);
    tr.setMeta(pluginKey, {
      textInserted: text,
      from: result.from,
      to: result.to,
      matchedRule: result.matchedRule,
      isBackwardMatch: isBackwardMatch
    });
    if (onBeforeRegexMatch) {
      onBeforeRegexMatch(tr);
    }
    view.dispatch(tr);
    return true;
  };
};
function findMatchOnRules(_ref3) {
  var rules = _ref3.rules,
    textToMatch = _ref3.textToMatch,
    from = _ref3.from,
    to = _ref3.to,
    state = _ref3.state,
    isBackwardMatch = _ref3.isBackwardMatch;
  for (var i = 0; i < rules.length; i++) {
    var _textToMatch$at;
    var rule = rules[i];

    // Some plugins like Typeahead require a whitespace before a trigger character.
    // We want them to fire inside a gap cursor. Yet, a gap cursor is not considered a whitespace,
    // and `textToMatch` contains the text in the previous block before the gap cursor.
    // Here is a workaround: if we inside a gap cursor, match the input rule only against the last typed character
    // (which may be a typeahead trigger) and ignore the rest.
    var matchString = isGapCursorSelection(state.selection) ? (_textToMatch$at = textToMatch.at(-1)) !== null && _textToMatch$at !== void 0 ? _textToMatch$at : '' : textToMatch;

    // EDITOR-2460
    // if the user is formatting text to inline code from R to L i.e. backwards
    if (rule.allowsBackwardMatch && isBackwardMatch && expValEquals('platform_editor_lovability_inline_code', 'isEnabled', true)) {
      var _match = rule.match.exec(matchString);
      if (!_match) {
        continue;
      }
      var matchEndPos = from + _match[0].length - 1;
      var _transform = rule.handler(state, _match, from, matchEndPos);
      if (_transform) {
        return {
          from: from,
          to: matchEndPos,
          matchedRule: _objectSpread(_objectSpread({}, rule), {}, {
            result: _match
          })
        };
      }
      return null;
    }
    var match = rule.match.exec(matchString);
    if (!match) {
      continue;
    }
    var parentNodeStartAt = state.selection.$from.start();
    var offset = Math.max(0, state.selection.$from.parentOffset - MAX_REGEX_MATCH);
    var fromFixed = Math.max(parentNodeStartAt + match.index + offset, 1);
    var transform = rule.handler(state, match, fromFixed, to);
    if (transform) {
      return {
        from: fromFixed,
        to: to,
        matchedRule: _objectSpread(_objectSpread({}, rule), {}, {
          result: match
        })
      };
    }
  }
  return null;
}